export const opportunitiesInitialState = {
	entities: {},
};



// WEBPACK FOOTER //
// ./src/redux/opportunities/opportunity.initialState.js